import styled from 'styled-components';

export const COLORS = {
  primary: '#854EE0',
  primaryDark: '#59249B',
  primarySoft: '#F5F0FD',
  primaryBorder: '#D5C2F5',
  text: '#2B313C',
  muted: '#6F747D',
  border: '#DDDDDD',
  divider: '#EEEEEE',
  success: '#1E7B3A',
  successSoft: '#DFF5E5'
};

export const Section = styled.section`
  margin-bottom: 20px;
`;

export const SectionTitle = styled.h3`
  color: ${COLORS.text};
  font-size: 16px;
  border-bottom: 1px solid ${COLORS.border};
  padding-bottom: 10px;
  margin: 0 0 12px;
  text-transform: uppercase;
`;

export const Card = styled.div`
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  padding: 0 16px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid ${COLORS.divider};

  &:last-child {
    border-bottom: none;
  }
`;

export const RowLabel = styled.span`
  display: block;
  font-size: 12px;
  color: ${COLORS.muted};
`;

export const RowValue = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.text};
`;

export const Badge = styled.span<{ variant: 'primary' | 'success' }>`
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 12px;
  color: ${({ variant }) => (variant === 'success' ? COLORS.success : COLORS.primaryDark)};
  background: ${({ variant }) =>
    variant === 'success' ? COLORS.successSoft : COLORS.primarySoft};
`;

export const InstallmentsBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  padding: 12px 16px;
  border: 1px solid ${COLORS.primaryBorder};
  border-radius: 8px;
  background: ${COLORS.primarySoft};
  color: ${COLORS.primaryDark};
`;

export const InstallmentsLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
`;

export const CurrencyIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${COLORS.primary};
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
`;

export const InstallmentsValue = styled.span`
  font-size: 16px;
  font-weight: 700;
`;

export const Notice = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  font-size: 13px;
  color: ${COLORS.muted};
`;
